import { AlertTriangle } from "lucide-react";
import type { CurriculumImportIssue } from "src/utils/curriculumImportIssues";

export const CurriculumImportIssuePanel = ({ issue }: { issue: CurriculumImportIssue }) => {
  const place = [issue.sourceRow ? `Sheet row ${issue.sourceRow}` : "", issue.lesson].filter(Boolean).join(" · ");
  const progress = issue.savedCount != null && issue.expectedCount != null ? `${issue.savedCount} of ${issue.expectedCount} rows are already saved.` : "";
  return <section className="rounded-lg border border-rose-300 bg-rose-50 p-3 text-sm text-rose-950" role="alert" aria-live="assertive">
    <div className="flex items-start gap-2">
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-rose-700" aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-semibold">{issue.title}</p>
        {place && <p className="mt-1 text-xs font-medium uppercase tracking-wide text-rose-800">{place}</p>}
        {progress && <p className="mt-1">{progress} Continue staging skips those rows.</p>}
      </div>
    </div>
    <dl className="mt-3 space-y-3">
      <div><dt className="text-xs font-semibold uppercase tracking-wide text-rose-800">What happened</dt><dd className="mt-1">{issue.whatHappened}</dd></div>
      <div><dt className="text-xs font-semibold uppercase tracking-wide text-rose-800">Why it stopped</dt><dd className="mt-1">{issue.why}</dd></div>
      <div>
        <dt className="text-xs font-semibold uppercase tracking-wide text-rose-800">How to resolve it</dt>
        <dd>
          <ol className="mt-1 list-decimal space-y-1 pl-4">
            {issue.resolution.map((step) => <li key={step}>{step}</li>)}
          </ol>
        </dd>
      </div>
    </dl>
    {issue.technicalDetail && (issue.code === "unknown" || issue.technicalDetail !== issue.whatHappened) && <details className="mt-3">
      <summary className="cursor-pointer text-xs font-medium text-rose-800">Technical detail</summary>
      <p className="mt-1 break-words font-mono text-xs text-rose-900">{issue.technicalDetail}{issue.code ? ` (${issue.code})` : ""}</p>
    </details>}
  </section>;
};
